import { setCheckoutState } from './BasketStorage';
import { GTMEventType } from './GTMEventType';
import { endSession } from './Session';
import { StatusCode } from './StatusCode';
import { sendGTMEvent } from '@/lib/gtm-wrapper';

export class ErrorHandler {
  static getMessage(error): { statusCode: number; message: string } {
    if (error && error.response && error.response.data) {
      const statusCode: number = error.response.data.meta?.statusCode ?? -1;
      const localizedMessage: string = getMessageFromObject(error.response.data.meta?.message);
      let message: string = 'Bir hata oluştu';

      if (statusCode === StatusCode.USER_IS_NOT_ANONYMOUS) {
        endSession();
      }

      switch (statusCode) {
        case StatusCode.RECEIVER_INFORMATION_MISSING:
        case StatusCode.SENDER_INFORMATION_MISSING:
          setCheckoutState(undefined);
          break;
        case StatusCode.BASKET_SETTINGS_MISMATCH:
          message =
            localizedMessage && localizedMessage !== 'basket settings mismatch'
              ? localizedMessage
              : 'Sepetinizde farklı bölge ya da zaman için ürünler var!';
          break;
        default:
          message = localizedMessage ?? 'Bir hata oluştu';
          break;
      }

      sendGTMEvent({
        event: GTMEventType.EXCEPTION,
        page_url: window?.location?.pathname || '',
        error_type: 'Request Error',
        fatal: false,
        message,
        statusCode,
      });

      return { statusCode, message };
    }

    return { statusCode: -1, message: 'Bir hata oluştu' };
  }
}

function getMessageFromObject(message): string {
  try {
    if (message == null) return 'Bir hata oluştu';
    if (typeof message === 'object') {
      return String(message.tr || message.en || message.message || 'Bir hata oluştu');
    }
    if (typeof message === 'string') {
      try {
        const parsed = JSON.parse(message);
        if (parsed && typeof parsed === 'object') {
          return String(parsed.tr || parsed.en || parsed.message || message);
        }
      } catch {
        // plain string
      }
      return message;
    }
    return String(message);
  } catch (e) {
    return 'Bir hata oluştu';
  }
}
